export const getUnixTimestamp = () => Math.floor(new Date().getTime() / 1000);
